import marketsData from "./markets.json";

export enum MarketRegion {
  NorthAmerica = "North America",
  AsiaPacific = "Asia-Pacific",
  Europe = "Europe",
  MiddleEast = "Middle-East",
  Global = "Global",
}

export interface Market {
  published: boolean;
  locale: string;
  marketName: string;
  countryCode: string;
  languageTag: string;
  languageCode: string;
  currencySymbol: string;
  currencyCode: string;
  languageName: string;
  region: MarketRegion;
  dateFormat: string;
}

export const markets = marketsData as Market[];

export const getMarketByLocale = (locale: string): Market | undefined => {
  return markets.find((market) => {
    return market.locale === locale;
  });
};
